import { IState } from 'shared/store';

export const isPrintVersionPhoneVisibilitySelector = (state: IState) => {
  return state.printModal.isPrintModeEnabled && state.printModal.isPhonesVisible;
};
